import React from 'react'
import '../createpassword/CreatePassword.css'
import { Link } from 'react-router-dom'

const CreatePassword = () => {
  return (
   
    
    <div className='create-pw-section w-100 position-relative'>
        <Link rel='stylesheet' to="/signup" className='back-btn'>Back</Link>
        <div className='create-pw-code-box d-flex flex-wrap align-content-center justify-content-center'>
            <h6 className='text-center'>Create Password</h6>
            <div className='create-pw-code-form w-100'>
                <form action="" className='d-flex align-items-center flex-wrap justify-content-between'>
                    <div class="input-box w-100 mb-3">
                        <input type="text" className="form-control text-left"  id="" placeholder="Enter Password" />
                    </div>
                    <div class="input-box w-100">
                        <input type="text" className="form-control text-left"  id="" placeholder="Confirm Password" />
                    </div>
                </form>
                {/* <p className='text-left mt-4'><Link rel='stylesheet' to="/persona-verification"></Link></p> */}
                <p className='text-center mt-4'><Link rel='stylesheet' to="/persona-verification">Next</Link></p>
            </div>
        </div>
    </div>
  )
}

export default CreatePassword
